
import {Box, ContainerProps, keyframes, styled} from '@mui/material';
import { rem } from 'polished';
import {headingSizes, headingType, weights, colors, textSizes} from "./theme/theme";

export const Container = styled('div')<ContainerProps>(
    ({ theme }) => ({
        width: '100%',
        display: 'flex',
        height: '100vh',
        flexDirection: 'row',
        backgroundColor: colors.grayDark4,
        [theme.breakpoints.down('sm')]: {
            flexDirection: 'column',
        },
    }),
);

export const LeftWrapper = styled('div')(({ theme }) => ({
    width: '50%',
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    [theme.breakpoints.down('sm')]: {
        width: '100%',
    },
}));

export const ImgWrapper = styled('div')(({ theme }) => ({
    width: rem(600),
    display: 'flex',
    flexDirection: 'column',
    justifyContent: 'center',
    alignItems: 'center',
    rowGap: rem(40),
    zIndex: 1,
    [theme.breakpoints.down('sm')]: {
        height: rem(80),
    },
}));

export const LogoImg = styled('img')(({ theme }) => ({
    [theme.breakpoints.down('sm')]: {
        width: rem(223),
    },
}));

export const OnboardingImg = styled('img')(({ theme }) => ({
    width: rem(416),
    [theme.breakpoints.down('sm')]: {
        display: 'none',
    },
}));

export const Content = styled('div')(({ theme }) => ({
    width: rem(695),
    backgroundColor: colors.white,
    zIndex: 1,
    [theme.breakpoints.down('md')]: {
        width: rem(512),
    },

    [theme.breakpoints.down('sm')]: {
        width: '100%',
        height: '100%',
    },
}));

export const Main = styled('div')(({ theme }) => ({
    width: rem(350),
    transform: `translateY(${rem(60)})`,
    margin: '0 auto',
    fontWeight: weights.normal,
    fontSize: textSizes.base,
    display: 'flex',
    justifyContent: 'flex-start',
    flexDirection: 'column',
    flexGrow: 1,
    flexWrap: 'wrap',
    rowGap: rem(25),
    maxWidth: rem(350),
    [theme.breakpoints.down('sm')]: {
        transform: `translateY(${rem(50)})`,
    },
    [theme.breakpoints.down('xs')]: {
        width: rem(300),
    },
}));

export const Form = styled('form')({
    display: 'flex',
    justifyContent: 'flex-start',
    flexDirection: 'column',
    flexGrow: 1,
    flexWrap: 'wrap',
    rowGap: rem(25),
});

export const Title = styled('div')({
    fontSize: rem(headingSizes.h1),
    fontWeight: weights.semiBold,
    fontFamily: headingType,
    color: colors.grayDark2,
});

export const Subtitle = styled('div')({
    color: colors.grayDark2,
});

export const Hint = styled('div')({
    color: colors.grayDark2,
    '> a': {
        textDecoration: 'underline',
    },
});

export const EmailIdentifier = styled('div')({
    color: colors.grayDark2,
    border: `${rem(1)} solid ${colors.gray}`,
    borderRadius: rem(100),
    textAlign: 'center',
    lineHeight: rem(35),
    cursor: 'pointer',
    maxWidth: rem(350),
    flexWrap: 'wrap',
    display: 'flex',
    height: 'auto',
    minHeight: rem(35),
    justifyContent: 'center',

    wordBreak: 'break-all',
    overflowWrap: 'break-word',
    whiteSpace: 'normal',
    padding: `0 ${rem(30)}`,
});

// export const StyledGoogleBtn = styled(Button)({
//   marginTop: rem(30),
//   color: colors.tertiary,
//   borderColor: colors.grayDark1,
//   ':hover': {
//     color: colors.tertiary,
//     borderColor: colors.gray,
//     backgroundColor: colors.grayLight3,
//   },
// });

export const StyledGoogleIcon = styled('img')({
    maxWidth: rem(20),
});

// export const StyledUseBackupBtn = styled(Button)({
//   color: colors.grayDark2,
//   backgroundColor: 'transparent',
//   width: 'fit-content',
//   padding: 0,
//   minWidth: 'unset',
//   borderRadius: 0,
//   justifyContent: 'start',
//   fontSize: textSizes.sm,
//   textTransform: 'none',
// });

export const StyledBackupSupportBox = styled(Box)({
    display: 'flex',
    justifyContent: 'start',
    gap: '5px',
});

export const StyledWrapper = styled(Box)({
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    width: '100%',
    height: '100vh',
    backgroundColor: colors.grayLight2,
});

export const blinkAnimation = keyframes`
  0% {
    opacity: 1;
  }
  50% {
    opacity: 0.35;
  }
  75% {
    opacity: 0.85;
  }
  100% {
    opacity: 1;
  }
`;

export const StyledLogo = styled('div')`
  width: 250px;
  height: 53px;
  background: url('/assets/logo.svg') no-repeat center center;
  animation: ${blinkAnimation} 3s linear infinite;
`;
